import React from 'react'
import { object, func } from 'prop-types'
import styles from './UserBiometricPage.styl'
import { FileUploadInput } from '../../components'

import { withContext } from '../../../utils/withContext'

function missingInfo(biometricData = {}) {
	const { birthday, height, restBPM, rMaxBPM } = biometricData
	if (!birthday) {
		return 'Data de nascimento em falta.'
	} else if (!height || !restBPM || !rMaxBPM) {
		return 'Informação biométrica em falta.'
	} else if (!birthday || !height || !restBPM || !rMaxBPM) {
		return null
	} else {
		return 'check'
	}
}

class UserBiometricPage extends React.Component {
	static propTypes = {
		athlete: object,
		handleSubmit: func,
		context: object
	}

	static getDerivedStateFromProps(nextProps, currentState) {
		const { biometricData: propsBiometricData, files } = nextProps.athlete
		const { biometricData, message: stateMessage } = currentState
		// TODO: tem de retornar mensagem
		const message = missingInfo(propsBiometricData) !== 'check'
		return { biometricData, files, message: !stateMessage ? stateMessage : message }
	}

	constructor(props) {
		super(props)
		const { biometricData, files } = props.athlete
		const message = missingInfo(biometricData) !== 'check'
		this.state = {
			biometricData: biometricData || {}, message, date: (biometricData || {}).birthday ? new Date(biometricData.birthday) : new Date(),
			files,
			ecgInput: '',
			bloodInput: ''
		}
		this.validate = this.validate.bind(this)
	}

	handleEcgFile(event) {
		this.setState({
			ecgInput: event.target.files[0]
		})
	}

	handleBloodFile(event) {
		this.setState({
			bloodInput: event.target.files[0]
		})
	}

	validate(e) {
		e.preventDefault()
		const { handleSubmit } = this.props
		const { biometricData, date } = this.state

		// this.setState({ biometricData: { birthday: date.getTime() } })

		if (isNaN(biometricData.height) || isNaN(biometricData.restBPM) || isNaN(biometricData.rMaxBPM)) {
			// window.alert('Por favor verifica se a tua altura e frequências cardíacas são um número')
			return
		}

		handleSubmit(e, { biometricData: { ...biometricData, birthday: date.getTime() } })
	}

	getMonthDays(month, year) {
		if (month.match(/^0|2|4|6|7|9|11/)) { return 31 } else if (month.match(/3|5|8|10/)) { return 30 } else if (year % 4 !== 0) { return 28 } else if (year % 100 !== 0 || year % 400 === 0) { return 29 } else { return 28 }
	}

	handleChange(e) {
		const date = new Date(this.state.date.getTime())
		const newMonth = e.target.value - 1
		const monthDays = this.getMonthDays(newMonth.toString())
		if (date.getDate() > monthDays) { date.setDate(monthDays) }
		date.setMonth(newMonth)
		this.setState({ date })
	}

	render() {
		const { context: { i18n } } = this.props
		const { biometricData, date, files, bloodInput, ecgInput } = this.state
		const days = new Array(this.getMonthDays(date.getMonth().toString())).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const month = new Array(12).fill().map((v, i) => <option key={ i } value={ i + 1 }>{ i + 1 }</option>)
		const years = new Array(new Date().getFullYear() - 1920).fill().map((v, i) => <option key={ i } value={ new Date().getFullYear() - i }>{ new Date().getFullYear() - i }</option>)
		return (
			<div className={ styles['profile'] }>
				<div className={ styles['content'] }>
					<form onSubmit={ this.validate }>
						<h2 className={ styles.title }>{ i18n`biometric_info_label` }</h2>
						<div className={ styles.dadosContainer } style={ { justifyContent: 'space-between' } }>
							<label>{ i18n`registry_birthday_label` }</label>
							<div>
								<select value={ this.state.date.getDate() } onChange={ (e) => this.setState({ date: new Date(date.setDate(e.target.value)) }) }>
									{ days }
								</select>
								<select value={ this.state.date.getMonth() + 1 } onChange={ this.handleChange.bind(this) }>
									{ month }
								</select>
								<select value={ this.state.date.getFullYear() } onChange={ (e) => this.setState({ date: new Date(date.setFullYear(e.target.value)) }) }>
									{ years }
								</select>
							</div>
							{/* <input type="date" placeholder="dd/mm/aaaa" value={biometricData.birthday ? biometricData.birthday : ''} onChange={(e) => this.setState({ biometricData: { ...biometricData, birthday: e.target.value } })} /> */ }
						</div>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_height_label` }</label>
							<input type="number" min="130" max="220" placeholder="0" value={ biometricData.height || '' } onChange={ (e) => this.setState({ biometricData: { ...biometricData, height: e.target.value } }) } />
						</div>
						{/* <div className={styles.dadosContainer}>
                        <label>Sexo</label>
                        <select>
                            <option>Escolha um</option>
                            <option onClick={(e) => this.setState({ biometricData: { ...biometricData, gender: "Feminino" } })} value="Feminino">Feminino</option>
                            <option onClick={(e) => this.setState({ biometricData: { ...biometricData, gender: "Masculino" } })} value="Masculino">Masculino</option>
                        </select>
                    </div> */}
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_rest_fc_label` }</label>
							<input type="number" min="30" max="220" placeholder="0" value={ biometricData.restBPM || '' } onChange={ (e) => this.setState({ biometricData: { ...biometricData, restBPM: e.target.value } }) } />
						</div>
						{/* <div className={styles.dadosContainer}>
                        <label>Freq. Card. Máxima Teórica (ppm)</label>
                        <input type="number" min="30" max="220" value={biometricData && biometricData.tMaxBPM ? biometricData.tMaxBPM || ''} onChange={(e) => this.setState({ biometricData: { ...biometricData, tMaxBPM: e.target.value } })} />
                    </div> */}
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_max_fc_label` }</label>
							<input type="number" min="30" max="220" placeholder="0" value={ biometricData.rMaxBPM || '' } onChange={ (e) => this.setState({ biometricData: { ...biometricData, rMaxBPM: e.target.value } }) } />
						</div>
						<div className={ styles.dadosContainer }>
							<label>Electro Cardiograma (ECG) <br /><small>(pdf, png, jpg)</small></label>
							<FileUploadInput
								file={ (files || {}).ecg }
								type="ecg"
							/>
						</div>
						<div className={ styles.dadosContainer }>
							<label>Análises ao Sangue <br /><small>(pdf, png, jpg)</small></label>
							<FileUploadInput
								file={ (files || {}).bloodTests }
								type="bloodTests"
							/>
						</div>
						<div className={ styles.submitButton }>
							<input type="submit" value={ i18n`save_label` } />
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withContext(UserBiometricPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserBiometricPage/UserBiometricPage.js